import React, { useEffect, useMemo, useState } from 'react';
import GlobalWrapper from '../../../components/Wrapper/GlobalWrapper';
import Stack from '@mui/material/Stack';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { getTCUploadStudentDetailsTable } from '../../../redux/features/crdMigrationSlice';
import GlobalTable from '../../../components/CustomTableWithPagination/GlobalTable';
import { TcUploadStudentDetailsHeader } from './utils/TcUploadStudentDetailsHeader';
import FromAndToDatePicker from '../../../components/mui/FromAndToDatePicker';
import dayjs from 'dayjs';

export default function TcUploadStudentDetails() {
  const dispatch = useDispatch();
  // Redux State-------------------------------------------------------------

  const loading = useSelector((state) => state.crdMigration.tcUploadStudentDetailsTable.loading);
  const tableData = useSelector((state) => state.crdMigration.tcUploadStudentDetailsTable.data);
  const meta = useSelector((state) => state.crdMigration.tcUploadStudentDetailsTable.meta);
  // -------------------------------------------------------------

  // Date state (default: current month)
  const [fromDate, setFromDate] = useState(dayjs().startOf('month').format('YYYY-MM-DD'));
  const [toDate, setToDate] = useState(dayjs().endOf('month').format('YYYY-MM-DD'));

  const [tableState, setTableState] = useState({
    page: 1,
    pageSize: 50,
    search: '',
    sort: { field: '', direction: 'asc' },
    frozenColumns: [],
    hiddenColumns: [],
  });
  // ---------------------------------------------------------

  //---------- DispatchParams ---------------------------------
  const dispatchParams = useMemo(
    () => ({
      fromDate,
      toDate,
      page: tableState.page,
      limit: tableState.pageSize,
      search: tableState.search,
      sortBy: tableState?.sort?.field,
      sortDirection: tableState?.sort?.direction,
    }),
    [fromDate, toDate, tableState?.page, tableState?.search, tableState?.sort, tableState?.pageSize],
  );

  //-------------------------------------------------------------

  //-------------- Table Fetch ------------------------------

  useEffect(() => {
    dispatch(getTCUploadStudentDetailsTable(dispatchParams));
  }, [dispatchParams, dispatch]);

  //-------------- Table Fetch ------------------------------

  return (
    <GlobalWrapper title={'TC Uploaded Student Details'}>
      <Stack gap={2}>
        <Stack direction={{ xs: 'column', sm: 'row' }} gap={1}>
          <FromAndToDatePicker
            disabled={false}
            fromDate={fromDate}
            toDate={toDate}
            setFromDate={setFromDate}
            setToDate={setToDate}
          />
        </Stack>

        <GlobalTable
          rowUniqueId="sl_no"
          headers={TcUploadStudentDetailsHeader}
          tableState={tableState}
          setTableState={setTableState}
          loading={loading}
          rows={tableData}
          meta={meta ?? {}}
        />
      </Stack>
    </GlobalWrapper>
  );
}
